import type { AiChatMessage } from '../../types/api.js';

let aiChatHistory: AiChatMessage[] = [];
let aiChatSending = false;
let aiChatInitSeq = 0;

export function getAiChatHistory(): AiChatMessage[] {
  return aiChatHistory;
}

export function setAiChatHistory(value: AiChatMessage[]): void {
  aiChatHistory = value;
}

export function pushAiChatHistoryMessage(message: AiChatMessage): void {
  aiChatHistory.push(message);
}

export function popAiChatHistoryMessage(): void {
  aiChatHistory.pop();
}

export function getAiChatSending(): boolean {
  return aiChatSending;
}

export function setAiChatSending(value: boolean): void {
  aiChatSending = value;
}

export function bumpAiChatInitSeq(): number {
  aiChatInitSeq += 1;
  return aiChatInitSeq;
}

export function getAiChatInitSeq(): number {
  return aiChatInitSeq;
}
